import React from 'react';
import { useTranslation } from 'react-i18next';

function Shimmer({ className }) {
    return <div className={`animate-pulse bg-gray-200 dark:bg-gray-700 rounded-lg ${className}`} />;
}

export function TripCardSkeleton() {
    return (
        <div className="card p-6 flex flex-col gap-3">
            <Shimmer className="w-12 h-12 rounded-full" />
            <Shimmer className="h-6 w-3/4" />
            <Shimmer className="h-4 w-1/2" />
            <div className="flex gap-2 mt-1">
                <Shimmer className="h-6 w-24 rounded-full" />
                <Shimmer className="h-6 w-24 rounded-full" />
            </div>
        </div>
    );
}

export function TripOverviewSkeleton({ onBack }) {
    const { t } = useTranslation();
    return (
        <div className="max-w-7xl mx-auto px-4 py-8 flex flex-col gap-6">
            <button onClick={onBack} className="btn-outline self-start text-sm">
                {t('tripOverview.backToTrips')}
            </button>
            <div className="card p-6 flex flex-col gap-4">
                <Shimmer className="h-8 w-2/3" />
                <div className="grid grid-cols-3 gap-4">
                    <Shimmer className="h-14" />
                    <Shimmer className="h-14" />
                    <Shimmer className="h-14" />
                </div>
            </div>
            <div className="card overflow-hidden">
                <div className="flex gap-1 p-3 border-b border-gray-200 dark:border-gray-700">
                    {[1,2,3,4,5].map(i => <Shimmer key={i} className="h-10 w-24" />)}
                </div>
                <div className="p-6 flex flex-col gap-4">
                    <Shimmer className="h-24 rounded-xl" />
                    <Shimmer className="h-24 rounded-xl" />
                    <Shimmer className="h-24 rounded-xl" />
                </div>
            </div>
        </div>
    );
}
